import ConfigForm from './ConfigForm.jsx';

const SCHEMA = [
  { key: 'placeholder', label: 'Placeholder', kind: 'text' },
  { key: 'pattern', label: 'Pattern (regex)', kind: 'text' },
  { key: 'min_length', label: 'Min length', kind: 'integer' },
  { key: 'max_length', label: 'Max length', kind: 'integer' },
];

export default function TextConfig({ field, onConfigChange }) {
  return <ConfigForm schema={SCHEMA} config={field.config} onConfigChange={onConfigChange} />;
}
